"use client";

import React, { useMemo } from "react";
import CountryPhonePrompt from "./CountryPhonePrompt";
import { useLanguage } from "@/contexts/LanguageContext";
import { getStrings } from "@/i18n/dictionaries";

/**
 * Component to display when user tries Zambia MoMo with non-Zambian phone
 * This is a wrapper around CountryPhonePrompt with Zambia-specific configuration
 */
export default function ZambiaPhonePrompt({
  onClose,
  onSwitchToStripe,
  detectedPhone,
  authPhone,
  profilePhone,
  profileCountry,
  selectedPaymentCountry,
}) {
  const { locale } = useLanguage();
  const t = useMemo(() => getStrings(locale, "payment"), [locale]);
  const zambiaConfig = {
    title: t.zambia_phone_title,
    requiredPrefix: "+260",
    requiredCountryName: "Zambia",
  };

  return (
    <CountryPhonePrompt
      onClose={onClose}
      onSwitchToStripe={onSwitchToStripe}
      onSwitchToBankTransfer={null}
      detectedPhone={detectedPhone}
      authPhone={authPhone}
      profilePhone={profilePhone}
      profileCountry={profileCountry}
      selectedPaymentCountry={selectedPaymentCountry}
      config={zambiaConfig}
    />
  );
}